import { Component, Input } from '@angular/core';

@Component({
  selector: 'lm-file-upload-progress',
  templateUrl: './lm-file-upload-progress.component.html',
  styleUrls: ['./lm-file-upload-progress.component.scss']
})
export class LMFileUploadProgressComponent {
  public progressPrecent = '0%';
  public progressValue = 0;

  @Input() set progress(value: number) {
    this.progressValue = value;
    this.progressPrecent = `${value}%`;
  }
}
